import PropTypes from "prop-types";

export default {
	addListener: PropTypes.func,
	startGrid: PropTypes.func,
};
